<template>
  <b-row>
    <b-col cols="8">
      <BfInput
        label="Nombre"
        data-key="nombre"
        :value="data.nombre"
        :edit-mode="editing"
        @update="updateForm"
        :errors="errors"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Clave"
        data-key="clave"
        :value="data.clave"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {

  name: 'JobForm',

  props: {
    data: {
      type: Object,
      default: () => ({
        nombre: '',
        clave: '',
      }),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
  },
};
</script>
